import React, {Component}                       from "react";
import {Platform, Text, TouchableOpacity, View} from "react-native";
import {connect}                                from "react-redux";
import {Camera}                                 from "expo-camera";
import * as FileSystem                          from "expo-file-system";
import * as Permissions                         from "expo-permissions";
import {Ionicons, MaterialIcons}                from "@expo/vector-icons";
import ModalPhotoConfirm                        from "../modals/ModalPhotoConfirm";
import * as Actions                             from "../../constants/Actions";
import * as Screens                             from "../../constants/Screens";
import styles                                   from "../../styles/Styles";

// CONSTANTS
// FLASH
const FLASH_ICONS = {
    auto:   "flash-auto",
    off:    "flash-off",
    on:     "flash-on",
    torch:  "highlight"
};

const FLASH_ORDER = {
    off:    "on",
    on:     "auto",
    auto:   "torch",
    torch:  "off"
};

// FOCUS
const FOCUS = {
    off:    "on",
    on:     "off"
}

// CAMERA TYPE (FRONT/BACK)
const TYPE = {
    back:   "front",
    front:  "back"
};

// WHITE BALANCE
const WB_ICONS = {
    auto:           "wb-auto",
    cloudy:         "wb-cloudy",
    fluorescent:    "wb-iridescent",
    incandescent:   "wb-incandescent",
    shadow:         "beach-access",
    sunny:          "wb-sunny"
};

const WB_ORDER = {
    auto:           "sunny",
    sunny:          "cloudy",
    cloudy:         "shadow",
    shadow:         "fluorescent",
    fluorescent:    "incandescent",
    incandescent:   "auto"
};

class ScreenCamera extends Component {
    state = {
        autoFocus:              "on",
        flash:                  "off",
        hasCameraPermission:    null,
        pictureSize:            undefined,
        pictureSizeId:          0,
        pictureSizes:           [],
        ratio:                  "16:9",
        type:                   "back",
        whiteBalance:           "auto",
        zoom:                   0
    };

    collectPictureSizes = async () => {
        if (this.camera) {
            const pictureSizes = await this.camera.getAvailablePictureSizesAsync(this.state.ratio);
            let pictureSizeId = 0;
            if (Platform.OS === "ios") {
                pictureSizeId = pictureSizes.indexOf("High");
            }
            else {
                // Array is sorted in ascending order
                pictureSizeId = pictureSizes.length-1;
            }
            this.setState({ pictureSizes, pictureSizeId, pictureSize: pictureSizes[pictureSizeId] });
        }
    }

    async componentDidMount() {
        //Verify camera permissions. Return to settings screen if permission denied.
        const camera = await Permissions.askAsync(Permissions.CAMERA);
        const hasCameraPermission = (camera.status === "granted");
        if (hasCameraPermission)
            this.setState({ hasCameraPermission });
        else
            this.props.changeScreen();

        //Create photo storage directory, if needed
        var dirPhotos = await FileSystem.getInfoAsync(FileSystem.cacheDirectory + "photos");
        if (!dirPhotos.exists)
            FileSystem.makeDirectoryAsync(FileSystem.cacheDirectory + "photos").catch(e => { console.log(e, "Directory exists"); });
    }

    handleMountError = ({message}) => console.error(message);

    onPictureSaved = async photo => {
        var data = await FileSystem.readAsStringAsync(photo.uri, { encoding: FileSystem.EncodingType.Base64 });
        this.props.showPhotoModal(data);
    }

    takePicture = () => {
        if (this.camera) {
            this.camera.takePictureAsync({ onPictureSaved: this.onPictureSaved });
        }
    };

    toggleFacing        = () => this.setState({ type:            TYPE[this.state.type] });
    toggleFlash         = () => this.setState({ flash:           FLASH_ORDER[this.state.flash] });
    toggleFocus         = () => this.setState({ autoFocus:       FOCUS[this.state.autoFocus] });
    toggleWB            = () => this.setState({ whiteBalance:    WB_ORDER[this.state.whiteBalance] });

    render() {
        if (this.state.hasCameraPermission === null)
            return <View />;
        if (!this.state.hasCameraPermission)
            return <Text>Access to camera has been denied.</Text>;

        return (
            <View style={styles.background}>
                <ModalPhotoConfirm />

                <Camera autoFocus={this.state.autoFocus} flashMode={this.state.flash} onCameraReady={this.collectPictureSizes}
                    onMountError={this.handleMountError} pictureSize={this.state.pictureSize} ratio={this.state.ratio}
                    ref={camera => {this.camera = camera;}} style={styles.camera} type={this.state.type} whiteBalance={this.state.whiteBalance}
                    zoom={this.state.zoom}>
                    
                    <View style={styles.cameraTopBar}>
                        <TouchableOpacity onPress={this.toggleFacing} style={styles.cameraToggleButton}>
                            <Ionicons color="white" name="ios-reverse-camera" size={32}/>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={this.toggleFlash} style={styles.cameraToggleButton}>
                            <MaterialIcons color="white" name={FLASH_ICONS[this.state.flash]} size={32}/>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={this.toggleWB} style={styles.cameraToggleButton}>
                            <MaterialIcons color="white" name={WB_ICONS[this.state.whiteBalance]} size={32}/>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={this.toggleFocus} style={styles.cameraToggleButton}>
                            <Text style={[styles.cameraAutoFocusLabel, { color: this.state.autoFocus === "on" ? "white" : "#6b6b6b" }]}>AF</Text>
                        </TouchableOpacity>   
                    </View>

                    <View style={styles.cameraBottomBar}>
                        <TouchableOpacity onPress={this.props.changeScreen} style={styles.cameraBottomButton}>
                            <Ionicons color="white" name="md-arrow-round-back" size={30}/>
                        </TouchableOpacity>
                        <View style={{ flex: 1 }}>
                            <TouchableOpacity onPress={this.takePicture} style={styles.cameraPhotoButton}>
                                <Ionicons color="white" name="ios-radio-button-on" size={70}/>
                            </TouchableOpacity>
                        </View>
                        {/* Invisible button for spacing purposes */}
                        <TouchableOpacity style={styles.cameraBottomButton}>
                            <Ionicons color="transparent" name="md-arrow-round-back" size={30}/>
                        </TouchableOpacity>
                    </View>
                </Camera>
            </View>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        changeScreen:   ()      => { dispatch({type: Actions.CHANGE_SCREEN,     screen:     Screens.SETTINGS_PLAYER}) },
        showPhotoModal: (data)  => { dispatch({type: Actions.SHOW_PHOTO_MODAL,  photoData:  data,                   showPhotoModal: true}) }
    };
}

export default connect(null, mapDispatchToProps)(ScreenCamera);